export default "__VITE_ASSET__CVoizz42__"